module.exports = __webpack_public_path__ + "static/media/crane.36c17f9d.png";